import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { reviewsData } from '../../data/reviewsData';
import './reviews.scss';

// Pegando as 5 avaliações mais recentes (últimas do array)
const reviews = reviewsData.slice(-5).reverse();

export default function Reviews() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const handleGoogleReview = () => {
    window.open('https://g.page/r/YOUR_GOOGLE_PLACE_ID/review', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="reviews">
      <div className="container">
        <motion.div 
          className="reviews-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Clientes de Lourdes recomendam</h2>
          <p className="section-subtitle">Avaliação excelente no Google de quem já escolheu praticidade e economia perto de casa.</p>
          
          <motion.div 
            className="reviews-stats"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="stats-item">
              <i className="ri-star-fill"></i>
              <span>Avaliação 4,9 no Google</span>
            </div>
          </motion.div>
        </motion.div>

        <div className="reviews-carousel">
          <button onClick={prevReview} className="carousel-btn prev" aria-label="Anterior">
            <i className="ri-arrow-left-s-line"></i>
          </button>

          <div className="reviews-container">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                className="review-card"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
              >
                <div className="review-stars">
                  {[...Array(reviews[currentIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <p className="review-comment">{reviews[currentIndex].comment}</p>
                <div className="review-author">
                  <div className="author-avatar">
                    {reviews[currentIndex].name.charAt(0)}
                  </div>
                  <div className="author-info">
                    <strong>{reviews[currentIndex].name}</strong>
                    <span>Cliente verificado</span>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <button onClick={nextReview} className="carousel-btn next" aria-label="Próximo">
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>

        <div className="reviews-dots">
          {reviews.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Ir para avaliação ${index + 1}`}
            />
          ))}
        </div>

        <motion.div 
          className="reviews-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <button onClick={handleGoogleReview} className="review-btn">
            <i className="ri-star-line"></i>
            Nos avalie também
          </button>
        </motion.div>
      </div>
    </section>
  );
}